var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkflowInput',{class:_vm.base,attrs:{"placeholder":_vm.$t(`${_vm.pre}.placeholder`),"value":_vm.inputValue},on:{"change":function($event){_vm.value = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }